import iconCharcoalDarkSaved from "../../../Icons/icons-charcoal-dark/saved.png";
import iconCharcoalDarkliked from "../../../Icons/icons-charcoal-dark/liked.png";
import iconCharcoalDarkSave from "../../../Icons/icons-charcoal-dark/save.png";
import iconCharcoalDarkMenuUp from "../../../Icons/icons-charcoal-dark/menu-up.png";
import iconCharcoalDarkMenuDown from "../../../Icons/icons-charcoal-dark/menu-down.png";
import iconWhiteExit from "../../../Icons/NV/white/exit.png";

import generateHtml from "./generate-html";
import firebase from "../firebase";
import spinner from "../spinner";

import GENRALHELPERS from "../GENRAL-HELPERS";
import handleAccount from "../register/handle-account";
import register from "../register/register";
import StackDisplay from "../../modules/stack-display/display";
import BusinessDisplayEach from "../display-business-each/display";
import allHandeling from "../handeling-all-displays/all-handeling";
import shareNow from "../share-now/share-now";
import displayBusiness from "../display-business-each/display";

import iconYellowSave from "../../../Icons/NV/yellow/save.png";
import iconYellowSaved from "../../../Icons/NV/yellow/saved.png";


import iconWhiteSave from "../../../Icons/NV/white/save.png";
import iconWhiteSaved from "../../../Icons/NV/white/saved.png";


import businessPageEditor from "../business-page-editor/business-page-editor";
import homeScreen from "../home-screen/home-screen";



import iconBackImg from "../../../Icons/NV/white/back-img.png";
import iconForwardImg from "../../../Icons/NV/white/forward-img.png";
import { count } from "firebase/firestore";



const MainOneOnOverTheOther = document.getElementById("MainOneOnOverTheOther");

let debounceTimeout;

const images = [
  "355c0a80-0eb4-4bc7-b28e-cbe202dfa29b.jpg",
  "e612ac7a-ee51-466f-a682-79c2db0c6ee3.jpg",
  "7bee6f00-cdf6-415d-ae51-ff197f76f61b.jpg",
  "c0b2dfa0-f006-487b-9ee8-ef21d2245af3.jpg",
];

class display {
  #currentListing;
  #currentBusiness;
  #inititlazied = false;
  #listingEventsInitialized = false
  #currentImgIndex = 1
  constructor() {
    this._windowEvents()
  }

  _getCurrentImageIndex() {
    return this.#currentImgIndex;
  }
  _resetCurrentImageIndex() {
    console.log('CALLED');
    this.#currentImgIndex = 1
  }

  _windowEvents() {
    // Scroll sync logic
    window.addEventListener("click", (e) => {
      const mini = e.target.closest(".nvImgDisplayerListingEachCon3");
      if (!mini) return;

      const wrapper = mini.closest(".nvListingEachCon1A");
      if (!wrapper) return;

      const bigScroller = wrapper.querySelector(".nvImgDisplayerListingEachCon1");
      const miniContainer = wrapper.querySelector(".nvImgDisplayerListingEachCon5");
      if (!bigScroller || !miniContainer) return;

      const allMinis = Array.from(miniContainer.querySelectorAll(".nvImgDisplayerListingEachCon3"));
      const index = allMinis.indexOf(mini);
      if (index < 0) return;

      // Scroll big container to the corresponding big image
      const target = bigScroller.querySelectorAll(".nvImgDisplayerListingEachCon2")[index];
      if (target) {
        target.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      }

      // Update active class
      // Happening in the sroll detector

      // allMinis.forEach((m, i) => {
      //   m.classList.toggle("nvImgDisplayerListingEachCon3ACT", i === index);
      // });
    });

  }

  // Detect scroll to update active mini image
  _detectBigImageScroll() {
    document.querySelectorAll(".nvImgDisplayerListingEachCon1").forEach((bigScroller) => {

      bigScroller.addEventListener("scroll", () => {
        const wrapper = bigScroller.closest(".nvListingEachCon1A");
        const miniContainer = wrapper?.querySelector(".nvImgDisplayerListingEachCon5");
        if (!miniContainer) return;

        const bigImages = Array.from(bigScroller.querySelectorAll(".nvImgDisplayerListingEachCon2"));
        const minis = Array.from(miniContainer.querySelectorAll(".nvImgDisplayerListingEachCon3"));

        // Find current visible big image
        const scrollLeft = bigScroller.scrollLeft;
        const width = bigScroller.clientWidth;
        const index = Math.round(scrollLeft / width);

        this.#currentImgIndex = index + 1;

        console.log(index);

        minis.forEach((mini, i) => {
          mini.classList.toggle("nvImgDisplayerListingEachCon3ACT", i === index);
        });
      });
    });
  }

  _returnMiniSpinner() {
    return `<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="20"
      height="20"
      class="miniSpinneForButtons">
      <circle
        cx="25"
        cy="25"
        r="20"
        stroke="#2B2B2B"
        stroke-width="4"
        fill="none"
        stroke-dasharray="125.6"
        stroke-dashoffset="94.2"
        stroke-linecap="round">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.8s"
          repeatCount="indefinite" />
      </circle>
    </svg>`;
  }



  _videoHandler() {
    document.addEventListener("click", function (event) {
      // Close button logic
      if (event.target.classList.contains("close-btn")) {
        const wrapper = event.target.closest(".floating-video");
        if (wrapper) wrapper.remove();
        return;
      }

      // Play overlay logic
      const overlay = event.target.closest(".video-overlay");
      if (overlay) {
        const video = overlay.parentElement.querySelector("video");
        if (video) {
          overlay.remove();
          // overlay.style.display = "none";
          video.play();
        }
      }
    });
    function enableDrag(el) {
      const handle = el.querySelector(".drag-handle");
      if (!handle) return;

      let isDragging = false;
      let offsetX = 0;
      let offsetY = 0;

      function onPointerDown(e) {
        isDragging = true;
        const rect = el.getBoundingClientRect();
        offsetX = e.clientX - rect.left;
        offsetY = e.clientY - rect.top;

        el.style.transition = "none";
        document.addEventListener("pointermove", onPointerMove);
        document.addEventListener("pointerup", onPointerUp);

        // Prevent text selection while dragging
        e.preventDefault();
      }

      function onPointerMove(e) {
        if (!isDragging) return;
        e.preventDefault();

        const x = e.clientX - offsetX;
        const y = e.clientY - offsetY;

        el.style.left = `${x}px`;
        el.style.top = `${y}px`;
        el.style.right = "auto"; // override inline right positioning
      }

      function onPointerUp(e) {
        if (!isDragging) return;
        isDragging = false;

        const winWidth = window.innerWidth;
        const rect = el.getBoundingClientRect();

        // Snap to nearest edge (20px margin)
        if (rect.left + rect.width / 2 < winWidth / 2) {
          el.style.left = "20px";
        } else {
          el.style.left = "auto";
          el.style.right = "20px";
        }

        document.removeEventListener("pointermove", onPointerMove);
        document.removeEventListener("pointerup", onPointerUp);

        // Smooth snap
        el.style.transition = "left 0.2s ease, right 0.2s ease";
      }

      handle.addEventListener("pointerdown", onPointerDown);
    }
    document.querySelectorAll(".floating-video").forEach(enableDrag);
  }

  async _init(dataIn, businessIn, openFrom, share, fromEdit, rationClass) {
    console.error("INIT DISPLAY LISTING EACH");
    this.#currentImgIndex = 1;

    let data = dataIn;
    console.log(data);


    // this.#currentBusiness = business;

    let callNumber = "";
    let whatsAppNumber = "";
    let viewsData = "";




    let account = null
    let business = null


    if (data?.sellerId) {
      account = await firebase._getAnyDocById(`accounts/${data?.sellerId}`)
      const countryCodeCall = (account?.callNumberCountryCode || '52').replace('+', '');
      const countryCodeWhats = (account?.whatsAppNumberCountryCode || '52').replace('+', '');
      callNumber = countryCodeCall + account?.callNumber || ''
      whatsAppNumber = countryCodeWhats + account?.whatsAppNumber || ''
    }

    if (data?.businessId) {
      business = await firebase._getAnyDocById(`businesses/${data?.businessId}`)
      const countryCodeCall = (business?.contacts?.call?.countryCode || '52').replace('+', '');
      const countryCodeWhats = (business?.contacts?.whatsApp?.countryCode || '52').replace('+', '');
      callNumber = countryCodeCall + business?.contacts?.call?.contact || ''
      whatsAppNumber = countryCodeWhats + business?.contacts?.whatsApp?.contact || ''
    }


    if (fromEdit === "true") {
      data = businessPageEditor._getPlaceHolderListingData();
      console.log("OPEN LISTING FROM EDIT");
    } else {
      if (business) {
        viewsData = {
          businessId: business.businessId,
          listingId: data.listingId,
        };
      } else {
        viewsData = {
          listingId: data.listingId,
        };
      }

      firebase._updateViewsOnListings(viewsData);
    }

    console.log(business);
    this.#currentListing = null;
    this.#currentBusiness = null;
    this.#currentListing = data;

    spinner._displaySpinner("Cargando información");

    const idForConTainer = GENRALHELPERS._getUniqueIdfunction();
    const imgUrls = data.listingImgsIds;

    const dataForListing = { data, ads: homeScreen._makeAddSetToInsert() }

    let listingHTML = generateHtml._generateListing(
      dataForListing,
      business,
      imgUrls,
      null,
      { callNumber, whatsAppNumber },
      openFrom,
      fromEdit,
      rationClass
    )

    StackDisplay._display(
      listingHTML
    );

    console.log(data);


    if (data?.place?.locationUrl) {
      const nvListingEachConLocationContainerParent = document.getElementById('nvListingEachConLocationContainerParent')
      const openMapsButton = document.getElementById('nvListingEachConLocationContainerButtonOpenMaps')

      const listignDataForLocation = {
        title: data.listingName,
        description: data.listingDescription,
        imageUrl: data.listingImgsIds[0].res_200,
        lat: data.place.lat,
        lng: data.place.lng,
        price: data.onDiscount.finalPrice,
        city: data.place.city,
        state: data.place.state,
        locationUrl: data.place.locationUrl,
      }

      console.log(listignDataForLocation);

      nvListingEachConLocationContainerParent.style.display = 'flex'

      GENRALHELPERS._displayListingLocation(listignDataForLocation, 'nvListingEachConLocationContainer')

      openMapsButton.addEventListener('click', () => {
        GENRALHELPERS._openOutboundLink(listignDataForLocation.locationUrl)
      })
    }

    console.log(share);
    if (share) {
      const listingCon = document.getElementById(
        `${idForConTainer}ForInstantSharing`
      );
      console.log(listingCon);
      const shareButton = listingCon.querySelector(
        "#DisplayListingEachButtonActionShare"
      );
      console.log(shareButton);
      // shareButton.click();
      this._shareListing(shareButton);
    }

    spinner._hideSpinner();
    // if (this.#inititlazied) return;
    // this.#inititlazied = true;
    this._videoHandler();
    this._detectBigImageScroll()
    this._listingEvents();


    const historySaveUrl = await GENRALHELPERS._createUrlForSharing(
      dataIn.businessId,
      null,
      dataIn.listingId,
      null
    );

    const historyData = {
      href: historySaveUrl,
      title: dataIn.listingName,
      image: data?.listingImgsIds?.[0]?.res_200 || null,
      type: 'listing', // item | category | search
    }

    GENRALHELPERS._pushUserHistory(historyData)


    this._setExpandedContactsButton(false)
    setTimeout(() => {
      this._setExpandedContactsButton(true)
    }, 500)
    this._initScrollListener()

  }


  _initScrollListener() {
    const container = document.querySelector('.nvListingEachCon1C');

    let isAtTop = true;

    container.addEventListener('scroll', () => {

      const nowAtTop = container.scrollTop <= 0;

      // Left the top
      if (isAtTop && !nowAtTop) {
        isAtTop = false;
        this._setExpandedContactsButton(false)
      }

      // Returned to the top
      else if (!isAtTop && nowAtTop) {
        isAtTop = true;
        this._setExpandedContactsButton(true)
      }

    });

  }
  _setExpandedContactsButton(expanded = true) {
    const parent = document.getElementById('nvListingsContactEachCon13C')
    const el = parent.querySelector('.nvBusinessContactEachCon14ListingEach')
    const el2 = parent.querySelector('.nvBusinessContactEachCon13CListingEach')
    const text1 = parent.querySelector('.nvBusinessContactEachText12ListingEach')
    const text2 = parent.querySelector('.nvBusinessContactEachText11ListingEach')
    const text3 = parent.querySelector('.nvListingEachCon17ListingEach')

    if (expanded) {
      parent.classList.add('expanded');
      el.classList.add('expanded');
      el2.classList.add('expanded');
      text1.style.display = 'flex'
      text2.style.display = 'flex'
      text3.style.display = 'flex'
    } else {
      parent.classList.remove('expanded');
      el.classList.remove('expanded');
      el2.classList.remove('expanded');
      text1.style.display = 'none'
      text2.style.display = 'none'
      text3.style.display = 'none'
    }
  }

  _shareListing = async (e) => {
    const parentEL = e.closest(".ActionForShare");
    const shareWhat = parentEL.dataset.share;
    const businessId = parentEL.dataset.businessid;
    const listingId = parentEL.dataset.listingid;
    const businessName = parentEL.dataset.businessname;
    const listingName = parentEL.dataset.listingname;
    const listingPrice = parentEL.dataset.listingprice;
    const listingPriceBefore = parentEL.dataset.listingpricebefore;
    const listingCoin = parentEL.dataset.listingcoin;

    let imgsUrls = [];
    let imgsUrlsAll = [];
    const siblingWithImgCon = parentEL.nextElementSibling?.classList.contains(
      "imgCon"
    )
      ? parentEL.nextElementSibling
      : parentEL.previousElementSibling?.classList.contains(
        "ListingDisplayImagesDisplayCon1"
      )
        ? parentEL.previousElementSibling
        : null;

    if (siblingWithImgCon) {
      siblingWithImgCon
        .querySelectorAll(".ListingDisplayImagesDisplayImage")
        .forEach((img) => {
          imgsUrlsAll.push(img.src);
        });
      imgsUrls = [imgsUrlsAll[0]];
    }

    console.log("Sibling with class 'imgCon':", siblingWithImgCon);

    let businessNameForUse = false;
    console.log(businessName);
    if (businessName !== "null" && businessName !== null) {
      businessNameForUse = businessName;
    }

    const url = await GENRALHELPERS._createUrlForSharing(
      businessId,
      businessNameForUse,
      listingId,
      listingName
    );

    const dataToSendToShareFunction = {
      listing: this.#currentListing,
      business: this.#currentBusiness,
      listingUrl: url,
    };

    shareNow._open(dataToSendToShareFunction, "listing");

  };

  _listingEvents() {

    if (this.#listingEventsInitialized) return
    this.#listingEventsInitialized = true

    window.addEventListener('click', (e) => {
      const isWhatsAppButton = e.target.closest('#btnActionListingContactWhatsApp')
      const isShareButton = e.target.closest('#btnActionListingShare')
      const isSaveButton = e.target.closest('#btnActionListingSave')
      const isOptionsButton = e.target.closest('#btnActionListingOptions')


      if (isWhatsAppButton ||
        isShareButton ||
        isSaveButton ||
        isOptionsButton) {
        const isListingBigParent = e.target.closest('.nvListingEachCon1A')
        const businessId = isListingBigParent.getAttribute("data-businessid") || "";
        const sellerId = isListingBigParent.getAttribute("data-sellerid") || "";
        const listingId = isListingBigParent.getAttribute("data-listingid") || "";
        const lives = isListingBigParent.getAttribute("data-lives") || "";
        const from = isListingBigParent.getAttribute("data-from") || "";


        if (isWhatsAppButton) {
          const whatsAppNumber = isWhatsAppButton.dataset.whatsappnumber || ""
          console.log('open WhatsApp');

          if (!whatsAppNumber) return
          this._contactWhatsApp(listingId, sellerId, businessId, whatsAppNumber);
        }
        if (isShareButton) {
          console.log('open share');
          this._share(listingId, businessId, sellerId,);
        }
        if (isSaveButton) {
          console.log('open save');
          this._save(listingId);
        }
        if (isOptionsButton) {
          console.log('open options');
          // this._more(listingId);
          // alert('No hay mas opciones para este listado por el momento.')
        }
      }
    })
  }

  _hideImgOnSwipe() {
    const viewer = document.getElementById("MainContainerForImgDisplayer");
    const imageStrip = document.getElementById("MyOwnImgDisplayerNotAIsCon1");

    const dismissThreshold = 65;
    const directionLockDistance = 10;
    const maxDragDistance = window.innerHeight * 0.75;

    let startX = 0;
    let startY = 0;
    let isDraggingDown = false;
    let directionLocked = false;

    const resetDrag = () => {
      imageStrip.style.transition = "transform 180ms ease-out";
      imageStrip.style.transform = "translateY(0)";
      viewer.style.transition = "background-color 180ms ease-out";
      viewer.style.backgroundColor = "";

      setTimeout(() => {
        imageStrip.style.transition = "";
        viewer.style.transition = "";
      }, 180);
    };

    imageStrip.addEventListener("touchstart", (e) => {
      if (e.touches.length !== 1) return;

      const image = e.target.closest(".IsForZoom");

      // Zoom state is assigned by updateTransform below.
      if (image?.dataset.zoomed === "true") return;

      const touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      isDraggingDown = false;
      directionLocked = false;
    }, { passive: true });

    imageStrip.addEventListener("touchmove", (e) => {
      if (e.touches.length !== 1) return;

      const image = e.target.closest(".IsForZoom");

      // Never dismiss while the image is zoomed.
      if (image?.dataset.zoomed === "true") {
        if (isDraggingDown) resetDrag();
        isDraggingDown = false;
        return;
      }

      const touch = e.touches[0];
      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;

      // Wait for intentional movement, then decide whether it is vertical.
      if (!directionLocked) {
        if (
          Math.abs(deltaX) < directionLockDistance &&
          Math.abs(deltaY) < directionLockDistance
        ) {
          return;
        }

        directionLocked = true;

        // Preserve horizontal swiping between images and upward gestures.
        if (deltaY <= 0 || Math.abs(deltaX) > Math.abs(deltaY)) return;

        isDraggingDown = true;
      }

      if (!isDraggingDown) return;

      e.preventDefault();

      const dragY = Math.min(deltaY, maxDragDistance);
      const progress = Math.min(dragY / maxDragDistance, 1);

      imageStrip.style.transition = "none";
      imageStrip.style.transform = `translateY(${dragY}px)`;

      // Optional: fade the backdrop as the image moves down.
      viewer.style.backgroundColor = `rgba(0, 0, 0, ${1 - progress * 0.7})`;
    }, { passive: false });

    const finishDrag = () => {
      if (!isDraggingDown) return;

      const currentTransform = imageStrip.style.transform;
      const draggedDistance = Number(
        currentTransform.match(/translateY\(([\d.]+)px\)/)?.[1] || 0
      );

      isDraggingDown = false;

      if (draggedDistance >= dismissThreshold) {
        imageStrip.style.transition = "transform 180ms ease-in";
        imageStrip.style.transform = `translateY(${window.innerHeight}px)`;
        viewer.style.backgroundColor = "rgba(0, 0, 0, 0)";

        setTimeout(() => {
          viewer.style.display = "none";
          imageStrip.style.transform = "";
          imageStrip.style.transition = "";
          viewer.style.backgroundColor = "";
          viewer.style.transition = "";
        }, 180);

        return;
      }

      resetDrag();
    };

    imageStrip.addEventListener("touchend", finishDrag, { passive: true });
    imageStrip.addEventListener("touchcancel", resetDrag, { passive: true });
  }


  _myOwnImgDisplayerNotAIs(imgUrls, goTo = 1) {
    const container = document.getElementById("MainContainerForImgDisplayer");
    container.style.display = "flex";

    container.addEventListener("click", (e) => {
      const isCloseButton = e.target.closest(".closeImgBig");
      if (isCloseButton) {
        container.style.display = "none";
      }
    });

    let imgHtml = ``;
    imgUrls.forEach((img) => {
      imgHtml += `
      <div class="MyOwnImgDisplayerNotAIsCon1B">
        <img 
          class="MyOwnImgDisplayerNotAIsConIMG IsForZoom"
          src="${img}"
          loading="eager"
          fetchpriority="high"
          decoding="async"
        />
      </div>
    `;
    });

    const finalHtml = `
    <div class="ExitButtonForImgDisplayer closeImgBig topRightExitButtonOnFullScreenWindow">
      <img height="20px" src="${iconWhiteExit}" alt="" />
    </div>

    <div class="imgBackButtonForImgDisplayer">
      <img height="20px" src="${iconBackImg}" alt="" />
    </div>

    <div class="imgForwardButtonForImgDisplayer">
      <img height="20px" src="${iconForwardImg}" alt="" />
    </div>
    
    <div class="imgTrackerForImgDisplayer">
      <div id="imgTrackerForImgDisplayerText" class="imgTrackerForImgDisplayerText">1/${imgUrls.length}</div>
    </div>

    <div id="MyOwnImgDisplayerNotAIsCon1" class="MyOwnImgDisplayerNotAIsCon1">${imgHtml}</div>
  `;

    container.innerHTML = finalHtml;

    const scrollContainer = document.getElementById("MyOwnImgDisplayerNotAIsCon1");
    const trackerText = document.getElementById("imgTrackerForImgDisplayerText");

    const backBtn = container.querySelector(".imgBackButtonForImgDisplayer");
    const forwardBtn = container.querySelector(".imgForwardButtonForImgDisplayer");

    const totalImages = imgUrls.length;

    let currentIndex = Math.max(0, Math.min(goTo - 1, totalImages - 1));

    function scrollToIndex(index) {
      currentIndex = Math.max(0, Math.min(index, totalImages - 1));

      const scrollAmount = currentIndex * scrollContainer.clientWidth;

      scrollContainer.scrollTo({
        left: scrollAmount,
        behavior: "smooth",
      });

      trackerText.textContent = `${currentIndex + 1}/${totalImages}`;
      updateNavButtons();
    }

    function updateNavButtons() {
      if (backBtn) backBtn.style.opacity = currentIndex === 0 ? "0.3" : "1";
      if (forwardBtn) forwardBtn.style.opacity = currentIndex === totalImages - 1 ? "0.3" : "1";
    }

    // 🎯 Initial scroll
    requestAnimationFrame(() => {
      const scrollAmount = currentIndex * scrollContainer.clientWidth;

      scrollContainer.scrollTo({
        left: scrollAmount,
        behavior: "auto",
      });

      trackerText.textContent = `${currentIndex + 1}/${totalImages}`;
      updateNavButtons();
    });

    // 🔄 Scroll tracking
    let scrollTimeout = null;

    scrollContainer.addEventListener("scroll", () => {
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        const index = Math.round(
          scrollContainer.scrollLeft / scrollContainer.clientWidth
        );

        currentIndex = Math.max(0, Math.min(index, totalImages - 1));

        trackerText.textContent = `${currentIndex + 1}/${totalImages}`;
        updateNavButtons();
      }, 50);
    });

    // ⬅️➡️ Buttons
    if (backBtn) {
      backBtn.addEventListener("click", () => {
        scrollToIndex(currentIndex - 1);
      });
    }

    if (forwardBtn) {
      forwardBtn.addEventListener("click", () => {
        scrollToIndex(currentIndex + 1);
      });
    }

    // 🔍 Zoom logic (unchanged)
    let scale = 1;

    function updateContainerHeight(image) {
      const imageHeight = image.naturalHeight * scale;
      const container = document.getElementById("MyOwnImgDisplayerNotAIsCon1");
      container.style.height = `${Math.min(imageHeight, window.innerHeight)}px`;
    }

    const enableZoomForAll = () => {
      const images = document.querySelectorAll(".IsForZoom");

      images.forEach((image) => {
        let scale = 1;
        let offsetX = 0;
        let offsetY = 0;
        let renderedOffsetX = 0;
        let renderedOffsetY = 0;
        let panStartX = 0;
        let panStartY = 0;
        let pinchStartDistance = 0;
        let pinchStartScale = 1;
        let pinchImageX = 0;
        let pinchImageY = 0;
        let pinchBaseLeft = 0;
        let pinchBaseTop = 0;
        let lastTapTime = 0;
        let lastTapX = 0;
        let lastTapY = 0;

        const clampScale = (value) => Math.min(Math.max(value, 1), 3);

        // const updateTransform = () => {
        //   image.dataset.zoomed = scale > 1 ? "true" : "false";
        //   image.style.transformOrigin = "0 0";
        //   image.style.willChange = "transform";
        //   image.style.transition = "none";
        //   image.style.transform =
        //     `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
        //   renderedOffsetX = offsetX;
        //   renderedOffsetY = offsetY;
        // };

        const updateTransform = (animate = false) => {
          image.dataset.zoomed = scale > 1 ? "true" : "false";
          image.style.transformOrigin = "0 0";
          image.style.willChange = "transform";

          image.style.transition = animate
            ? "transform 280ms cubic-bezier(0.22, 1, 0.36, 1)"
            : "none";

          image.style.transform =
            `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;

          renderedOffsetX = offsetX;
          renderedOffsetY = offsetY;
        };

        const getDistance = (touches) => {
          const dx = touches[0].clientX - touches[1].clientX;
          const dy = touches[0].clientY - touches[1].clientY;
          return Math.hypot(dx, dy);
        };

        const getMidpoint = (touches) => ({
          x: (touches[0].clientX + touches[1].clientX) / 2,
          y: (touches[0].clientY + touches[1].clientY) / 2,
        });

        const keepImageVisible = () => {
          const viewerRect = container.getBoundingClientRect();
          const imageRect = image.getBoundingClientRect();
          const baseLeft = imageRect.left - renderedOffsetX;
          const baseTop = imageRect.top - renderedOffsetY;
          const scaledWidth = image.offsetWidth * scale;
          const scaledHeight = image.offsetHeight * scale;
          const minimumVisible = 48;

          const minX = scaledWidth > viewerRect.width
            ? viewerRect.right - baseLeft - scaledWidth
            : viewerRect.left - baseLeft - scaledWidth + minimumVisible;
          const maxX = scaledWidth > viewerRect.width
            ? viewerRect.left - baseLeft
            : viewerRect.right - baseLeft - minimumVisible;
          const minY = scaledHeight > viewerRect.height
            ? viewerRect.bottom - baseTop - scaledHeight
            : viewerRect.top - baseTop - scaledHeight + minimumVisible;
          const maxY = scaledHeight > viewerRect.height
            ? viewerRect.top - baseTop
            : viewerRect.bottom - baseTop - minimumVisible;

          offsetX = Math.min(maxX, Math.max(minX, offsetX));
          offsetY = Math.min(maxY, Math.max(minY, offsetY));
        };

        const toggleDoubleTapZoom = (clientX, clientY) => {
          const imageRect = image.getBoundingClientRect();
          const baseLeft = imageRect.left - renderedOffsetX;
          const baseTop = imageRect.top - renderedOffsetY;
          const imagePointX = (clientX - imageRect.left) / scale;
          const imagePointY = (clientY - imageRect.top) / scale;

          scale = scale > 1 ? 1 : 2;

          if (scale === 1) {
            offsetX = 0;
            offsetY = 0;
          } else {
            offsetX = clientX - baseLeft - imagePointX * scale;
            offsetY = clientY - baseTop - imagePointY * scale;
            keepImageVisible();
          }

          updateTransform(true);
        };

        image.addEventListener("wheel", (e) => {
          e.preventDefault();
          const imageRect = image.getBoundingClientRect();
          const baseLeft = imageRect.left - renderedOffsetX;
          const baseTop = imageRect.top - renderedOffsetY;
          const imagePointX = (e.clientX - imageRect.left) / scale;
          const imagePointY = (e.clientY - imageRect.top) / scale;

          scale = clampScale(scale + (e.deltaY < 0 ? 0.15 : -0.15));
          offsetX = e.clientX - baseLeft - imagePointX * scale;
          offsetY = e.clientY - baseTop - imagePointY * scale;

          if (scale === 1) {
            offsetX = 0;
            offsetY = 0;
          } else {
            keepImageVisible();
          }
          updateTransform();
        }, { passive: false });

        image.addEventListener("touchstart", (e) => {
          if (e.touches.length === 1) {
            const touch = e.touches[0];
            const now = Date.now();
            const elapsed = now - lastTapTime;
            const movedX = Math.abs(touch.clientX - lastTapX);
            const movedY = Math.abs(touch.clientY - lastTapY);

            if (elapsed < 280 && movedX < 35 && movedY < 35) {
              e.preventDefault();
              lastTapTime = 0;
              toggleDoubleTapZoom(touch.clientX, touch.clientY);
              return;
            }

            lastTapTime = now;
            lastTapX = touch.clientX;
            lastTapY = touch.clientY;
          }

          if (e.touches.length === 2) {
            e.preventDefault();
            const midpoint = getMidpoint(e.touches);
            const imageRect = image.getBoundingClientRect();
            pinchStartDistance = getDistance(e.touches);
            pinchStartScale = scale;
            pinchBaseLeft = imageRect.left - renderedOffsetX;
            pinchBaseTop = imageRect.top - renderedOffsetY;
            pinchImageX = (midpoint.x - imageRect.left) / scale;
            pinchImageY = (midpoint.y - imageRect.top) / scale;
          } else if (e.touches.length === 1 && scale > 1) {
            panStartX = e.touches[0].clientX;
            panStartY = e.touches[0].clientY;
          }
        }, { passive: false });

        image.addEventListener("touchmove", (e) => {
          if (e.touches.length === 2) {
            e.preventDefault();
            const midpoint = getMidpoint(e.touches);
            const currentDistance = getDistance(e.touches);
            scale = clampScale(pinchStartScale * (currentDistance / pinchStartDistance));
            offsetX = midpoint.x - pinchBaseLeft - pinchImageX * scale;
            offsetY = midpoint.y - pinchBaseTop - pinchImageY * scale;

            if (scale === 1) {
              offsetX = 0;
              offsetY = 0;
            } else {
              keepImageVisible();
            }
            updateTransform();
          } else if (e.touches.length === 1 && scale > 1) {
            e.preventDefault();
            const touch = e.touches[0];
            offsetX += touch.clientX - panStartX;
            offsetY += touch.clientY - panStartY;
            panStartX = touch.clientX;
            panStartY = touch.clientY;
            keepImageVisible();
            updateTransform();
          }
        }, { passive: false });

        image.addEventListener("touchend", (e) => {
          pinchStartDistance = 0;
          if (e.touches.length === 1 && scale > 1) {
            panStartX = e.touches[0].clientX;
            panStartY = e.touches[0].clientY;
          }
          if (scale <= 1) {
            scale = 1;
            offsetX = 0;
            offsetY = 0;
            updateTransform();
          }
        });

        image.addEventListener("touchcancel", () => {
          pinchStartDistance = 0;
        });
      });

      this._hideImgOnSwipe();
    };

    enableZoomForAll();



    const images = container.querySelectorAll(".IsForZoom");

    images.forEach((imgEl) => {
      let retries = 0;
      const maxRetries = 2;

      imgEl.addEventListener("error", () => {
        if (retries >= maxRetries) return;

        retries++;

        const url = new URL(imgEl.src);
        url.searchParams.set("retry", Date.now());

        imgEl.src = url.toString();
      });
    });
  }



  // New stuff down
  async _contactWhatsApp(id, sellerId, businessId, whatsAppNumber) {
    let seller = null
    let business = null
    let contactName = ''
    let contactNamePrefix = 'Les'

    spinner._displaySpinner("Preparando Contacto");
    if (businessId) {
      business = await firebase._getBusinessById(businessId);
    } else {
      seller = await firebase._getAnyDocById(`accounts/${sellerId}`);
    }

    if (business) {
      contactName = business?.name || ''
    } else {
      contactName = seller?.userName || ''
      contactNamePrefix = 'Te'
    }


    spinner._hideSpinner();


    const getUrlToCurrentListing = async () => {
      console.log(businessId);
      const url = await GENRALHELPERS._createUrlForSharing(
        businessId,
        sellerId,
        id
      );
      return url;
    };


    const url = await getUrlToCurrentListing();
    // console.log(this.#currentListing);
    const openWhatsApp = (phoneNumber, message) => {
      try {
        const encodedMessage = encodeURIComponent(message);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

        return whatsappUrl

        window.open(whatsappUrl, "_blank", "noopener,noreferrer");

        console.log("WhatsApp link opened:", whatsappUrl);
      } catch (error) {
        console.error("Error opening WhatsApp link:", error);
      }
    };


    const message = `${GENRALHELPERS._getSpanishGreetingForDay()}, *${contactName}*.\n${contactNamePrefix} estoy contactando desde ${url}\n\n*Mesaje:*`;


    GENRALHELPERS._openOutboundLink(openWhatsApp(whatsAppNumber, message))

      ;
  }

  async _share(id,) {
    spinner._displaySpinner("Preparando información para compartir");
    let business = null;
    if (this.#currentListing.businessId) {
      business = await firebase._getBusinessById(this.#currentListing.businessId);
      console.log(business);
    }
    spinner._hideSpinner();

    const listingName = this.#currentListing.listingName;
    const listingId = this.#currentListing.listingId;
    let businessName = "";
    let sellerId = this.#currentListing.sellerId || ''
    let businessId = this.#currentListing.businessId || ''
    console.log(id, businessId, sellerId);

    if (listingId !== id) {
      alert(
        "Hay un error en identificar este negocio. Por favor cierra este negocio y ábrelo de nuevo."
      );
      return;
    }
    console.warn(this.#currentListing.businessId);

    const getUrlToCurrentListing = async () => {
      console.log(businessId);

      if (this.#currentListing.businessId) {
        businessName = business.name;
        businessId = business.businessId;
      }
      const url = await GENRALHELPERS._createUrlForSharing(
        businessId,
        sellerId,
        id
      );
      return url;
    };

    const url = await getUrlToCurrentListing();
    const dataToSendToShareFunction = {
      listing: this.#currentListing,
      business: business,
      listingUrl: url,
    };
    shareNow._open(dataToSendToShareFunction, "listing");
  }
  async _save(id) {
    const btnActionListingSave = document.getElementById(
      "btnActionListingSave"
    );

    const business = displayBusiness._getCurrentBusiness();

    const listingId = this.#currentListing.listingId;
    let businessId = "";
    let path = `listings/${listingId}`;
    if (this.#currentListing.businessId) {
      businessId = business.businessId;
      path = `businesses/${businessId}/listings/${listingId}`;
    }

    const account = firebase._getLatestCurrentUserData();
    if (account) {
      console.log("clicked");

      const dataSendToShare = {
        listingId: listingId,
        businessId: businessId,
      };

      btnActionListingSave.insertAdjacentHTML(
        "beforeend",
        this._returnMiniSpinner()
      );

      console.log(businessId);

      const saveResult = await firebase._updateSavesOnListings(dataSendToShare);
      console.log(saveResult);

      if (saveResult.data.status === "success") {
        if (saveResult.data.action === "saved") {
          handleAccount._getAccountState();
          btnActionListingSave.querySelector("img").src = iconWhiteSaved;
          btnActionListingSave.querySelector(".miniSpinneForButtons").remove();
        }
        if (saveResult.data.action === "removed") {
          handleAccount._getAccountState();
          btnActionListingSave.querySelector("img").src = iconWhiteSave;
          btnActionListingSave.querySelector(".miniSpinneForButtons").remove();
        }
      }
    } else {
      register._displayOptions(
        null,
        "Para guardar un negocio tienes que tener una cuenta activa en este dispositivo."
      );
    }
  }
  _more(id) {
    alert(
      "Estamos desarollando mas funciones para ti. Gracias por tenernos paciencia mientras estamos trabajando. Si tienes algunas sugerencias, contáctanos."
    );
  }
}
export default new display();
